import { unsafeCSS } from 'lit-element';

function cssResult(cssText) {
    return unsafeCSS(cssText);
}

export { cssResult };
